import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SetupPasswordRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Get the token from the current URL
    const token = searchParams.get('token');
    
    if (token) {
      // Redirect to the main page with the token parameter
      navigate(`/?token=${token}`, { replace: true });
    } else {
      // If no token, just redirect to the main page
      navigate('/', { replace: true });
    }
  }, [navigate, searchParams]);

  return null; // This component doesn't render anything
};

export default SetupPasswordRedirect; 